import React from 'react';
import styled from 'styled-components';
import { Colors } from '@inplayer-org/inplayer-ui';
import { TooltipProps } from 'recharts';
import { useSelector } from 'react-redux';

// data
import { colors } from 'data/colors';

// types
import RootState from 'ducks/RootState';
import { ChartObject } from 'pages/MerchantPages/Analytics/components/PaymentsAnalyticsChart';

// utils
import formatNumber from 'utils/formatNumber';

export const Container = styled.div`
  background: ${Colors.white};
  padding: 1rem;
  border: 1px solid ${Colors.darkGray};
`;

const ColorSquare = styled.span.attrs<{ color: string }>(({ color }) => ({
  style: {
    background: color,
  },
}))`
  padding: 0 0.7rem;
  margin: 1rem 1rem 1rem 0;
`;

export const DataInfo = styled.span<{ color: string }>`
  color: ${({ color }) => color};
  padding: 1rem;
`;

export const Wrapper = styled.div`
  padding: 0.3rem 0;
`;

type Props = TooltipProps;

const CustomBarTooltip = ({ active, payload }: Props) => {
  const totalPayments = useSelector<RootState, number>((state) => state.payments.paymentAnalytics.total);
  const currenciesData: ChartObject = payload && payload[0] ? payload[0].payload : {};
  const totalPaymentsPerMethod = payload ? (payload[0]?.value as number) : 0;

  const currencyView = Object.keys(currenciesData)
    .filter((name) => !['Total', 'groupBy', 'name'].includes(name))
    .map((item, index) => {
      return (
        <Wrapper key={item}>
          <ColorSquare color={colors[index + 1]} />
          <DataInfo color={colors[index + 1]}>
            {item}: {formatNumber(currenciesData[item])}
          </DataInfo>
        </Wrapper>
      );
    });

  return active ? (
    <Container>
      <div>Detailed payments info</div>
      <Wrapper>
        <ColorSquare color={colors[0]} />
        {totalPaymentsPerMethod && totalPayments && (
          <DataInfo color={colors[0]}>
            Total number of payments: {formatNumber(totalPaymentsPerMethod)} /{' '}
            {((totalPaymentsPerMethod / totalPayments) * 100).toFixed(2)}%
          </DataInfo>
        )}
      </Wrapper>

      {currencyView}
    </Container>
  ) : null;
};

export default CustomBarTooltip;
